const actionType = {
    SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
};
export default actionType;
